import urlcat from 'urlcat';

import { createClient } from '../client';

import { CONSUL_DIRECTORY } from '../config/endpoints';

const baseURL = urlcat('', CONSUL_DIRECTORY);
const client = createClient(baseURL);

export default class ConsulDirectory {
  static async settings() {
    return client.get('/settings');
  }
}
